'use client';

/**
 * Håller det senast inträffade oväntade felet, så att rapportdialogen kan visa rätt referens
 * oavsett var i appen felet uppstod.
 *
 * Ersätter `sessionStorage['last_server_error']`, som rapportsidan läste men som ingenting
 * någonsin skrev — därför var traceId alltid 'unknown'.
 *
 * Medvetet en enkel modulnivåstore i stället för en context: axios-interceptorn ligger utanför
 * React-trädet och måste kunna skriva hit utan att vara i en komponent.
 */

export type Felpost = {
  /** Referenskoden från servern, t.ex. FEL-7K3M9Q. Saknas om anropet aldrig nådde fram. */
  referens?: string;
  /** Texten som visas för användaren. Aldrig en stacktrace. */
  meddelande: string;
  tidpunkt: Date;
  /** Sidan användaren stod på. */
  sökväg?: string;
  /** Anropet som brast, när felet kom från ett API-anrop. */
  anrop?: string;
  status?: number;
};

let senasteFel: Felpost | null = null;
const prenumeranter = new Set<(fel: Felpost | null) => void>();

export function registreraFel(fel: Felpost): Felpost {
  senasteFel = fel;
  prenumeranter.forEach((lyssnare) => lyssnare(senasteFel));
  return fel;
}

export function hämtaSenasteFel(): Felpost | null {
  return senasteFel;
}

export function rensaFel(): void {
  senasteFel = null;
  prenumeranter.forEach((lyssnare) => lyssnare(null));
}

export function prenumereraPåFel(lyssnare: (fel: Felpost | null) => void): () => void {
  prenumeranter.add(lyssnare);
  return () => {
    prenumeranter.delete(lyssnare);
  };
}
